export const BANNER_TYPES = [
  { value: "Promotional", label: "Promotional" },
  { value: "Educational", label: "Educational" },
  { value: "Seasonal", label: "Seasonal" },
];

export const BANNER_STATUSES = [
  { value: "PENDING", label: "Pending" },
  { value: "ACTIVE", label: "Active" },
  { value: "SCHEDULED", label: "Scheduled" },
  { value: "INACTIVE", label: "Inactive" },
];

export const BANNER_AUDIENCES = [
  { value: "ALL", label: "Everyone" },
  { value: "TUTOR", label: "Tutors only" },
  { value: "PARENT", label: "Parents only" },
];

export const emptyBannerForm = {
  title: "",
  bannerType: "",
  status: "PENDING",
  audience: "ALL",
  onlyActiveClass: false,
  startDate: "",
  endDate: "",
  redirectUrl: "",
};

export const toDateTimeLocal = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const pad = (part) => String(part).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

export const formatBannerDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const audienceLabel = (value, onlyActiveClass = false) => {
  const label = BANNER_AUDIENCES.find((item) => item.value === (value || "ALL"))?.label || "Everyone";
  return onlyActiveClass ? `${label}, running class only` : label;
};

export const statusLabel = (value) =>
  BANNER_STATUSES.find((item) => item.value === value)?.label || value || "Pending";

export const scheduleLabel = (banner) => {
  const start = formatBannerDate(banner.startDate);
  const end = formatBannerDate(banner.endDate);
  if (start && end) return `${start} – ${end}`;
  if (start) return `From ${start}`;
  if (end) return `Until ${end}`;
  return "No schedule";
};

export const validateBannerForm = (form, { requireImage = false, hasImage = false } = {}) => {
  if (!form.title.trim()) return "Please enter banner title";
  if (!form.bannerType) return "Please select banner type";
  if (requireImage && !hasImage) return "Please select a banner image";
  if (!form.audience) return "Please choose who should see this banner";
  if (form.status === "SCHEDULED" && !form.startDate) {
    return "Start date and time is required for a scheduled banner";
  }
  if (form.startDate && form.endDate && new Date(form.endDate) <= new Date(form.startDate)) {
    return "End date must be after the start date";
  }
  const link = form.redirectUrl.trim();
  if (link) {
    try {
      const url = new URL(link);
      if (!["http:", "https:"].includes(url.protocol)) {
        return "Banner link must start with http or https";
      }
    } catch {
      return "Banner link must be a valid URL";
    }
  }
  return "";
};

export const appendBannerFields = (data, form) => {
  data.append("title", form.title.trim());
  data.append("bannerType", form.bannerType);
  data.append("status", form.status);
  data.append("audience", form.audience || "ALL");
  data.append("onlyActiveClass", form.onlyActiveClass ? "true" : "false");
  data.append("startDate", form.startDate ? new Date(form.startDate).toISOString() : "");
  data.append("endDate", form.endDate ? new Date(form.endDate).toISOString() : "");
  data.append("redirectUrl", form.redirectUrl.trim());
};

export const STATUS_HELP = {
  PENDING:
    "Pending banners stay off the tutor and parent apps. Audience, dates, and link are saved, so you can activate or schedule them later.",
  ACTIVE:
    "Shown now. Everyone, tutors only, or parents only — whichever you picked. An end time hides it automatically.",
  SCHEDULED:
    "Stays hidden until the start time, then appears for the selected audience. After the end time it turns inactive.",
  INACTIVE: "Hidden from both apps. Switch it to Active or Scheduled when it should appear again.",
};
